/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverSalaryAdminDto } from '../models/DriverSalaryAdminDto';
import type { PutDriverSalaryRequestAdmin } from '../models/PutDriverSalaryRequestAdmin';
import type { SalarySystemType } from '../models/SalarySystemType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverSalariesService {
    /**
     * **Required Policy:** `ViewDriverSalaries`
     * @returns DriverSalaryAdminDto OK
     * @throws ApiError
     */
    public static getDriverSalariesAdmin({
        driverId,
        salarySystemId,
        salarySystemType,
        regionId,
        page,
        limit,
    }: {
        driverId?: number,
        salarySystemId?: number,
        salarySystemType?: SalarySystemType,
        regionId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<DriverSalaryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driversalaries',
            query: {
                'driverId': driverId,
                'salarySystemId': salarySystemId,
                'salarySystemType': salarySystemType,
                'regionId': regionId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverSalaries`
     * @returns DriverSalaryAdminDto OK
     * @throws ApiError
     */
    public static getDriverSalaryAdmin({
        driverSalaryId,
    }: {
        driverSalaryId: number,
    }): CancelablePromise<DriverSalaryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driversalaries/{driverSalaryId}',
            path: {
                'driverSalaryId': driverSalaryId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverSalaries`
     * @returns DriverSalaryAdminDto OK
     * @throws ApiError
     */
    public static getDriverSalaryByDriverAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<DriverSalaryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driversalaries/driver/{driverId}',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriversSalaries`
     * @returns DriverSalaryAdminDto OK
     * @throws ApiError
     */
    public static putDriverSalaryAdmin({
        driverId,
        requestBody,
    }: {
        driverId: number,
        requestBody?: PutDriverSalaryRequestAdmin,
    }): CancelablePromise<DriverSalaryAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driversalaries/driver/{driverId}',
            path: {
                'driverId': driverId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
